import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'
import {TopicSchema} from './topic'
import {ResourceSummarySchema} from './resource-summary'

/**
 * Payload schema for taxonomy-based dynamic index pages.
 * Used for index pages where resources are fetched dynamically
 * based on selected topics from the taxonomy service.
 */
export const DynamicIndexPayloadSchema = z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    topics: z.array(TopicSchema),
    resources: z.array(ResourceSummarySchema).optional(),
    additionalProps: z
      .object({
        topic_ids: z.array(z.string()).optional(),
        totalPages: z.number().optional(),
        sortOptions: z
          .array(
            z.object({
              label: z.string(),
              value: z.string(),
            }),
          )
          .optional(),
        currentSort: z.string().optional(),
      })
      .optional(),
  }),
)

export type DynamicIndexPayload = z.infer<typeof DynamicIndexPayloadSchema>

export function toDynamicIndexPayload(payload: unknown): DynamicIndexPayload {
  return DynamicIndexPayloadSchema.parse(payload)
}

export function isDynamicIndexPayload(payload: unknown): payload is DynamicIndexPayload {
  return DynamicIndexPayloadSchema.safeParse(payload).success
}
